import { ChangeEvent, memo } from 'react'
import { useTranslation } from 'react-i18next'

import Search from '@/src/assets/icons/Search'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

interface IParticipantSearchProps {
  onSearch: (value: string) => void
}

export const ParticipantSearch = memo(function ParticipantSearch({
  onSearch,
}: IParticipantSearchProps) {
  const { t } = useTranslation()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value

    onSearch(value)
  }

  const { border_radius } = useAppSelector(selectBranding)

  return (
    <div className="participant-search " style={{ position: 'relative' }}>
      <div className="search">
        <Search fill="red" />
      </div>

      <input
        className="lk-form-control styleInput lk-chat-form-input"
        id="username"
        name="username"
        placeholder={t('findParticipant')}
        type="text"
        style={{ borderRadius: `${border_radius}px`, width: '100%' }}
        autoComplete="off"
        onChange={handleChange}
      />
    </div>
  )
},
arePropsEqual)

function arePropsEqual(oldProps: IParticipantSearchProps, newProps: IParticipantSearchProps) {
  return oldProps.onSearch === newProps.onSearch
}
